import type { ReactNode } from 'react';
import { Text, type TextProps } from '@mantine/core';

export interface CellTextProps extends Omit<TextProps, 'truncate' | 'lineClamp'> {
  children: ReactNode;
  /** Lines shown before the ellipsis. */
  lines?: number;
  /** The full text on hover; defaults to the children when they are a string. */
  title?: string;
}

/**
 * Free text in a table cell that never widens the table: at most `lines` lines ending in an
 * ellipsis, the whole text in `title`. It clamps rather than truncates, so even one line wraps
 * internally and long unbreakable tokens (object names, paths, error codes) break anywhere: the
 * column's minimum width is `miw`, not the text's, and `maw` caps its share of the spare width.
 */
export function CellText({ children, lines = 1, title, style, ...rest }: CellTextProps) {
  const full = title ?? (typeof children === 'string' ? children : undefined);
  return (
    <Text {...rest} title={full} lineClamp={lines} style={{ overflowWrap: 'anywhere', ...(style as object | undefined) }}>
      {children}
    </Text>
  );
}
